module.exports = __webpack_public_path__ + "media/images/cart_black-4ebb370de025a2777d784b288353c6f0.svg";